export const TwCommonHeaderStyles = {
  container: "flex z-[3] flex-nowrap relative min-h-900 py-150 md:py-350",
  showDateTabs: "xl:top-0 xl:my-0",
  logo: "focus-visible:ring [&_svg]:max-sm:max-h-400",
  formRoot:
    "sm:relative sm:top-350 sm:-mt-350 sm:mb-450 xl:top-400 xl:-mt-400 xl:mb-500"
};
